<script>
  import '../node_modules/tachyons/css/tachyons.min.css';
  import '../node_modules/leaflet/dist/leaflet.css';
  import '../public/fonts.css';
  import '../public/main.css';

  import FacilityList from './FacilityList.svelte';
  import FacilitySearch from './FacilitySearch.svelte';
  import FactorFilter from './FactorFilter.svelte';
  import MobileFactorFilter from './MobileFactorFilter.svelte';
  import InfoBox from './InfoBox.svelte';
  import Map from './Map.svelte';
  import Legend from './Legend.svelte';

  import {
    facilities,
    factorKey,
    highlightFacilityId,
    centroids,
    reboundMap,
    facilitySearchToggle,
    listCount,
    floodDomain,
    heatDomain,
    wildfireDomain,
    floodColorScale,
    heatColorScale,
    wildfireColorScale,
    searchTerm,
    iceOnly
  } from './stores.js';

  let facilitiesValue;
  let facilitySearchValue;

  facilities.subscribe((v) => {
    facilitiesValue = v;
    // console.log(facilitiesValue);
  });

  function setFacility(facilityId) {
    // console.log(facilityId);
    highlightFacilityId.set(facilityId);
  }

  function factorSort(factor, a, b) {
    if (a.properties[factor] > b.properties[factor]) {
      return -1;
    }
    if (a.properties[factor] < b.properties[factor]) {
      return 1;
    }
    return 0;
  }

  facilitySearchToggle.subscribe((v) => {
    facilitySearchValue = v;
  });

  function setFacilitySearch(val) {
    // console.log('setFacilitySearch', val);
    facilitySearchToggle.set(val);
  }

  function colorScale(factorKey) {
    switch (factorKey) {
      case 'flood_risk_rating':
        return floodColorScale;
      case 'heat_risk_rating':
        return heatColorScale;
      case 'wildfire_risk_rating':
        return wildfireColorScale;
      default:
        return floodColorScale;
    }
  }

  function legendTitle(factorKey) {
    switch (factorKey) {
      case 'flood_risk_rating':
        return 'Flood Risk';
      case 'heat_risk_rating':
        return 'Heat Risk';
      case 'wildfire_risk_rating':
        return 'Wildfire Risk';
      default:
        return 'Flood Risk';
    }
  }
</script>

<main class="TIMono tl" style="background-color: #2C2B2B">
  <div
    class="relative flex flex-wrap flex-nowrap-ns items-start overflow-hidden"
    style="height:100vh"
  >
    <p class="dn db-ns absolute top-1 left-2 ml3 mr0 ph0 mv0 pv0 z-999">
      <a class="pointer" href="https://theintercept.com"
        ><img src="TI_Logo.svg" alt="The Intercept" class="ti-logo" /></a
      >
    </p>
    <div class="db dn-em dn-ns mobile-header w-100">
      <p class="mt3 mb0 mh0 pv0 pr2 TIHeavy ttu title-text-mobile">
        Climate and Punishment
      </p>
      <p class="ma0 TI w-100 title-link-text" style="color: #fff">
        <a
          href="https://theintercept.com/series/climate-and-punishment"
          class="link"
          style="color: #e5e5e5">About the Project</a
        >
        |
        <a
          href="https://theintercept.com/2022/02/12/climate-and-punishment-data-methodology/"
          class="link"
          style="color: #e5e5e5">Methodology and Data</a
        >
      </p>
    </div>
    <div class="w-100 w-80-ns relative">
      <!-- map -->
      <Map
        geojson={$facilities}
        factorKey={$factorKey}
        highlightFacility={$highlightFacilityId}
        centroids={$centroids}
        reboundMap={$reboundMap}
        {setFacility}
      />
      <FacilitySearch />
      <MobileFactorFilter />
      <Legend color={colorScale($factorKey)} title={legendTitle($factorKey)} />
    </div>
    <!-- right bar -->
    <div
      class="w-100 w-20-ns right-bg vh-100 min-vh-100 flex flex-column items-stretch"
      style="min-width: 375px"
    >
      <p class="dn db-ns mt3 mb0 mh0 pv0 pr2 TIHeavy ttu title-text">
        Climate and<br />Punishment
      </p>
      <p class="dn db-ns ma0 TI w-100 title-link-text" style="color: #fff">
        <a
          href="http://theintercept.com/series/climate-and-punishment"
          class="link"
          style="color: #e5e5e5">About the Project</a
        >
        |
        <a
          href="https://theintercept.com/2022/02/12/climate-and-punishment-data-methodology/"
          class="link"
          style="color: #e5e5e5">Methodology and Data</a
        >
      </p>

      <div class="dn db-ns">
        <FactorFilter />
      </div>

      {#if !$highlightFacilityId}
        <div style="color: #888" class="mv3 ph3 flex w-100">
          <span class="w-10 dn"
            ><img src="list-icon.svg" alt="all facilities" /></span
          >
          <span class="dib f6 w-100 tc ttu">
            {#if $searchTerm}
              "{$searchTerm}"
            {:else if $iceOnly}
              ICE Facilities
            {:else}
              Facilities (Top {$listCount})
            {/if}
          </span>
        </div>
        <FacilityList />
      {/if}

      <!-- info box -->
      {#if $highlightFacilityId}
        <InfoBox
          facility={$facilities.features.filter((f) => {
            return f && f.properties.facilityid == $highlightFacilityId;
          })[0]}
          closeInfoBox={() => {
            highlightFacilityId.set(null);
          }}
        />
      {/if}
      <!-- info box -->
    </div>
    <!-- right bar -->
  </div>
</main>

<style>
</style>
